__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("launchdarkly-react-client-sdk", "3.3.2", () => (() => (__webpack_require__(/*! ../../../../../launchdarkly-react-client-sdk/lib/esm/index.js */ "../../../../../launchdarkly-react-client-sdk/lib/esm/index.js"))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(/*! ../../../../../react-dom/index.js */ "../../../../../react-dom/index.js"))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(/*! ../../../../../react-redux/es/index.js */ "../../../../../react-redux/es/index.js"))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(/*! ../../../../../react-router-dom/esm/react-router-dom.js */ "../../../../../react-router-dom/esm/react-router-dom.js"))), 1);
			register("react-toastify", "7.0.4", () => (() => (__webpack_require__(/*! ../../../../../react-toastify/dist/react-toastify.esm.js */ "../../../../../react-toastify/dist/react-toastify.esm.js"))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(/*! ../../../../../react/index.js */ "../../../../../react/index.js"))), 1);
			register("sonner", "1.7.2", () => (() => (__webpack_require__(/*! ../../../../../sonner/dist/index.mjs */ "../../../../../sonner/dist/index.mjs"))), 1);
			initExternal("webpack/container/reference/common");
			initExternal("webpack/container/reference/cf");
			initExternal("webpack/container/reference/cloudsinc");
			initExternal("webpack/container/reference/community");
			initExternal("webpack/container/reference/crs");
			initExternal("webpack/container/reference/crs-mi");
			initExternal("webpack/container/reference/fts");
			initExternal("webpack/container/reference/helpdesk");
			initExternal("webpack/container/reference/iam");
			initExternal("webpack/container/reference/klite");
			initExternal("webpack/container/reference/krdp-foundation");
			initExternal("webpack/container/reference/krdp-rs-asic");
			initExternal("webpack/container/reference/krdp-rs-cftc");
			initExternal("webpack/container/reference/krdp-rs-cftc43");
			initExternal("webpack/container/reference/krdp-rs-cftc45");
			initExternal("webpack/container/reference/krdp-rs-csa");
			initExternal("webpack/container/reference/krdp-rs-emir");
			initExternal("webpack/container/reference/krdp-rs-hkma");
			initExternal("webpack/container/reference/krdp-rs-jfsa");
			initExternal("webpack/container/reference/krdp-rs-mas");
			initExternal("webpack/container/reference/krdp-rs-mifid");
			initExternal("webpack/container/reference/krdp-rs-sec43");
			initExternal("webpack/container/reference/krdp-rs-sec45");
			initExternal("webpack/container/reference/krdp-rs-sftr");
			initExternal("webpack/container/reference/lrh");
			initExternal("webpack/container/reference/network-foundation");
			initExternal("webpack/container/reference/networking");
			initExternal("webpack/container/reference/sds");
			initExternal("webpack/container/reference/srb");
			initExternal("webpack/container/reference/ssil");
			initExternal("webpack/container/reference/wiki");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};